import { useDocumentSnapshot } from '../../../firebase/firestore/hooks';
import BookingDetailPresenter from './BookingDetailPresenter';
import { Seeker } from '../../../firebase/firestore/documents/seeker';
import { Collections } from '../../../firebase/firestore/collections';

export const useSeekerExperiences = (seekerId: string | undefined) => {
  const selectedSeeker = useDocumentSnapshot<Readonly<Seeker>>(Collections.SEEKERS, seekerId);
  return new BookingDetailPresenter(selectedSeeker);
};
